import { Component, OnInit, ViewChild } from '@angular/core';
import { FileContainerComponent } from 'src/app/modules/file-descriptor/components/file-container/file-container.component';
import { BasicModalOperationResult, DialogModalComponent, IBasicModalComponentInstance } from 'src/app/shared/components/dialog-modal/dialog-modal.component';
import { DismissReason } from 'src/app/shared/extensions/ng-active-modal/dismiss-reason';
import { DocumentProcessService } from 'src/app/core/services/api/document-process.service';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GuidHelper } from 'src/app/core/helpers/guid-helper';
import { VerifyResponse } from '../../../../core/models/verify-response.model';
import { DateHelper } from 'src/app/core/helpers/date-helper';
import { ConstancyType } from 'src/app/core/models/enums/constancyType';

@Component({
  selector: 'app-verification',
  templateUrl: './verification.component.html',
  styleUrls: ['./verification.component.scss']
})
export class VerificationComponent implements OnInit {
  showSpinner: boolean = true;
  submitting: boolean = false;
  fileDescriptorId: string;
  verifyResponse: VerifyResponse = new VerifyResponse();
  @ViewChild("fileContainer") fileContainer: FileContainerComponent;
  constancyType = ConstancyType;
  constancyTypeKeys = [];
  
  constructor(
    public translate: TranslateService,
    private documentProcessService: DocumentProcessService,
    private modalService: NgbModal
  ) {
    this.constancyTypeKeys = this.enumValues(this.constancyType);
   }

  ngOnInit() {
    this.showSpinner = false;
  }
// todo: pasar a helper
enumKeys(target: Record<string, number | string>): string[] {
  const allKeys: string[] = Object.keys(target);
  const parsedKeys: string[] = [];

  for (const key of allKeys) {
    const needToIgnore: boolean
      = target[target[key]]?.toString() === key && !isNaN(parseInt(key));

    if (!needToIgnore) {
      parsedKeys.push(key);
    }
  }

  return parsedKeys;
}

enumValues(target: Record<string, number | string>): Array<string | number> {
  const keys: string[] = this.enumKeys(target);
  const values: Array<string | number> = [];

  for (const key of keys) {
    values.push(target[key]);
  }

  return values;
}
  async verifyDocument() {
    try {
      this.submitting = true;
      this.showSpinner = true;

      if (this.fileContainer) {
        await this.fileContainer.commitFiles();
      }

      this.verifyResponse = await this.documentProcessService.verifyDocument(this.fileDescriptorId);
      this.showSpinner = false;
      this.submitting = false;

      if (this.verifyResponse.isVerified) {
        await this.showVerifiedDocumentMessage();
      } else {
        await this.showNotVerifiedDocumentMessage();
        this.fileDescriptorId = null;
      }
    } catch (error) {
      this.showSpinner = false;
      const modalInstance = this.modalService.open(DialogModalComponent)
        .componentInstance as IBasicModalComponentInstance;
      modalInstance.title = "Error";
      modalInstance.body = this.translate.instant("verification.verifyDocumentError");
      modalInstance.type = BasicModalOperationResult.Error;

      this.submitting = false;
    }
  }

  isAbleToVerify() {
    return this.fileDescriptorId && this.fileDescriptorId != '' && !GuidHelper.isEmptyGuid(this.fileDescriptorId);
  }

  async showVerifiedDocumentMessage() {
    const modalRef = this.modalService.open(DialogModalComponent, {
      backdrop: "static",
      keyboard: false,
    });

    const modalInstance =
      modalRef.componentInstance as IBasicModalComponentInstance;
    modalInstance.title = this.translate.instant("verification.verifiedDocument");
    modalInstance.body = this.translate.instant("verification.verifiedDocument");

    modalInstance.type = BasicModalOperationResult.Success;

    await modalRef.result;
  }

  async showNotVerifiedDocumentMessage() {
    const modalRef = this.modalService.open(DialogModalComponent, {
      backdrop: "static",
      keyboard: false,
    });

    const modalInstance =
      modalRef.componentInstance as IBasicModalComponentInstance;
    modalInstance.title = this.translate.instant("verification.notVerifiedDocumentTitle");
    modalInstance.body = this.translate.instant("verification.notVerifiedDocumentBody");

    modalInstance.type = BasicModalOperationResult.Error;

    await modalRef.result;
  }

  convertDate(dateToBeConverted: Date) {
    return DateHelper.convertDate(dateToBeConverted)
  }

}
